import { render, staticRenderFns } from "./DestinationRespectsCard.vue?vue&type=template&id=340cefba&"
import script from "./DestinationRespectsCard.vue?vue&type=script&lang=ts&"
export * from "./DestinationRespectsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports